import { render } from "./CardGraph.vue?vue&type=template&id=0b2b035a"
import script from "./CardGraph.vue?vue&type=script&lang=js"
export * from "./CardGraph.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__